import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import './styles.scss';

export default class SaveButton extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    component: PropTypes.object,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    labelLocation: PropTypes.string,
    notificationDuration: PropTypes.number,
    notificationLabel: PropTypes.string,
    saved: PropTypes.bool,
    saving: PropTypes.bool,
    savingLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onClick: PropTypes.func.isRequired,
    onSavedAcknowledgement: PropTypes.func
  }

  static defaultProps = {
    className: 'btn-save',
    label: 'Save',
    labelLocation: 'left',
    notificationDuration: 1000,
    notificationLabel: 'Saved',
    savingLabel: 'Saving...',
    onSavedAcknowledgement: () => {}
  }

  state = {
    renderNotification: false,
    renderNotificationTimeout: null
  }

  componentDidUpdate(previousProps) {
    const { notificationDuration, saved, onSavedAcknowledgement } = this.props;

    if (saved && !previousProps.saved) {
      onSavedAcknowledgement();

      clearTimeout(this.state.renderNotificationTimeout);
      const timeout = setTimeout(() => this.setState({ renderNotification: false }), notificationDuration);

      this.setState({
        renderNotification: true,
        renderNotificationTimeout: timeout
      });
    }
  }

  render() {
    const {
      className,
      component,
      disabled,
      label,
      notificationDuration,
      notificationLabel,
      saved,
      saving,
      savingLabel,
      onSavedAcknowledgement,
      ...props
    } = this.props;

    const buttonProps = {
      ...props,
      children: saving ? savingLabel : label,
      disabled: disabled || saving,
    };

    const Component = component;
    if (Component) {
      buttonProps.className = className;
    } else {
      buttonProps.className = `btn ${className}`;
    }

    return (
      <div className="form-save-button d-inline-block">
        {this.props.labelLocation === 'left' && this.renderNotification()}
        {Component ? <Component {...buttonProps} /> : <button {...buttonProps} />}
        {this.props.labelLocation === 'right' && this.renderNotification()}
      </div>
    );
  }

  renderNotification() {
    if (!this.state.renderNotificationTimeout) {
      // Check that the notification has ever been rendered to avoid having it rendered on mount
      return;
    }

    const className = classNames('form-save-button-notification', 'text-success', 'mr-3', {
      visible: this.state.renderNotification,
      'mr-3 me-3': this.props.labelLocation === 'left',
      'ml-3 ms-3': this.props.labelLocation === 'right'
    });

    return (
      <strong className={className} name="saved-notification">
        <FontAwesomeIcon className="mr-1 me-1" icon={faCheck}></FontAwesomeIcon>
        {this.props.notificationLabel}
      </strong>
    );
  }
}
